import Dexie, { type Table } from 'dexie';

export interface DraftEntry {
  id?: number;
  localId: string;
  serverId?: string;
  userId: string;
  claimId: string;
  type: 'mileage' | 'petty-cash';
  data: Record<string, unknown>;
  syncStatus: 'pending' | 'synced' | 'error';
  retryCount?: number;
  deleted?: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export class OfflineDb extends Dexie {
  drafts!: Table<DraftEntry>;

  constructor() {
    super('rhpc-offline');
    this.version(1).stores({
      drafts: '++id, localId, serverId, claimId, type, syncStatus, deleted',
    });
    this.version(2)
      .stores({
        drafts: '++id, localId, serverId, userId, claimId, type, syncStatus, deleted',
      })
      .upgrade(async (tx) => {
        await tx.table('drafts').clear();
      });
  }
}

export const db = new OfflineDb();
